function getConsent() {
	const raw = document.cookie.split('; ').find((row) => row.startsWith('cookieConsent='));
	return raw ? JSON.parse(decodeURIComponent(raw.split('=')[1])) : {};
}
function updateControls() {
	Object.entries(getConsent()).forEach(([key, value]) => {
		const checkbox = document.querySelector(`input[type="checkbox"][name="${key}"]`);
		if (checkbox) {
			checkbox.checked = value;
		}
	});
}

updateControls();

const fonts = {
	small: '50%',
	normal: '62.5%',
	big: '100%',
};

// Change font size
const fontsize = localStorage.getItem('fontsize');
if (fontsize) {
	document.querySelector('html').style.setProperty('font-size', fonts[fontsize]);
}

document.querySelectorAll('.font-size-btn').forEach((item) => {
	item.addEventListener('click', function (e) {
		const type = e.target.getAttribute('data-fontsize');
		if (getConsent().functional) {
			localStorage.setItem('fontsize', type);
		}
		document.querySelector('html').style.setProperty('font-size', fonts[type]);
	});
});

// Change contrast
if (localStorage.getItem('contrast') === 'true') {
	document.body.classList.add('contrast');
}

document.querySelectorAll('.contrast-btn').forEach((item) => {
	item.addEventListener('click', function () {
		if (document.body.classList.contains('contrast')) {
			document.body.classList.remove('contrast');
			localStorage.removeItem('contrast');
		} else {
			document.body.classList.add('contrast');
			if (getConsent().functional) {
				localStorage.setItem('contrast', 'true');
			}
		}
	});
});

function setProfileName(name) {
	document.querySelectorAll('.user-profile-name').forEach((place) => {
		// eslint-disable-next-line no-param-reassign
		place.innerText = name;
	});
}
setProfileName(window['profile-name'] ? window['profile-name'] : '');

window.addEventListener('load', () => {
	let profileName = document.querySelector('.zmiana-profilu .user-context-item.selected .title');
	profileName = profileName ? profileName.innerText.trim() : '';

	window['profile-name'] = profileName;
	setProfileName(profileName);

	window.keycloak.onAuthenticated(requestUserNotifications);
});

async function requestUserNotifications() {
	console.info('requestUserNotifications');

	const url = '/api/notifications/unread/count';
	const bearerToken = window.keycloak?.getBearerToken();

	if (!bearerToken) return console.warn('requestUserNotifications: No bearerToken');

	const data = await fetch(url, { headers: new Headers({ Authorization: bearerToken }) }).then((res) => res.json());

	document.querySelectorAll('#notifications-counter').forEach((count) => {
		count.textContent = data.count > 9 ? '9+' : data.count;

		if (data?.count > 0) count.style.display = '';
	});

	document.querySelectorAll('#notifications-count').forEach((notificationsIcon) => {
		notificationsIcon._tippy.setContent(`${Liferay.Language.get('notifications-count')}: ${data.count}`);
	});
}

window.addEventListener('load', () => {
	Array.from(document.getElementsByClassName('nav-link')).forEach((navLink) => {
		if (navLink.getAttribute('href') === window.location.href) {
			navLink.setAttribute('href', 'javascript:window.location.reload(true)');
		}
	});
});

if (getConsent().analytics) {
	window.addEventListener('load', () => {
		const matomoInput = document.getElementById('matomoUrl');
		if (matomoInput && matomoInput.value) {
			const _paq = (window._paq = window._paq || []);
			/* tracker methods like "setCustomDimension" should be called before "trackPageView" */
			_paq.push(['trackPageView']);
			_paq.push(['enableLinkTracking']);
			(function () {
				const u = matomoInput.value;
				_paq.push(['setTrackerUrl', `${u}/matomo.php`]);
				_paq.push(['setSiteId', '2']);
				const d = document;
				const g = d.createElement('script');
				const s = d.getElementsByTagName('script')[0];
				g.async = true;
				g.src = `${u}/matomo.js`;
				s.parentNode.insertBefore(g, s);
			})();
		}
	});
}

function setProfileIcon(company) {
	document.querySelectorAll('.user-profile-icon').forEach((icon) => {
		// eslint-disable-next-line no-param-reassign
		icon.src = icon.getAttribute('data-imagesUrl') + (company ? 'company.svg' : 'user.svg');
		// eslint-disable-next-line no-param-reassign
		icon.style.display = 'block';
	});
}

// eslint-disable-next-line consistent-return
async function downloadTypeOfAccount() {
	const url = '/api/user-profiles/profile/current';
	const bearerToken = window.keycloak?.getBearerToken();

	if (!bearerToken) return console.warn('profileTypeChange: No bearerToken');
	const data = await fetch(url, { headers: new Headers({ Authorization: bearerToken }) }).then((res) => res.json());

	return data.type === 'BUSINESS_ENTITY';
}
window.addEventListener('load', () => {
	window.keycloak.onAuthenticated(async () => {
		if (localStorage.getItem('downloadingTypeOfAccountProfileName') !== window['profile-name']) {
			localStorage.setItem('downloadingTypeOfAccountProfileName', window['profile-name']);

			const company = await downloadTypeOfAccount();
			setProfileIcon(company);
			localStorage.setItem('downloadingTypeOfAccount', company);
		} else {
			setProfileIcon(localStorage.getItem('downloadingTypeOfAccount') === 'true');
		}
	});
});
